import React, { useState } from 'react';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import styled from 'styled-components';

type Props = {
  onSelect: (value: number) => () => void;
  filteredIndexes: number[];
};

export function DuplicateSlot({ filteredIndexes, onSelect }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      onClickOutside={() => setIsOpen(false)}
      clickOutsideCapture
      positions={[`bottom`, `top`]}
      isOpen={isOpen}
      containerStyle={{ zIndex: `99999` }}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor="white"
          arrowClassName="change-target-arrow"
          arrowSize={10}
        >
          <Strategies>
            {filteredIndexes?.map((value) => (
              <Duplicate onClick={onSelect(value)}>
                Duplicate slot {value + 1}
              </Duplicate>
            ))}
          </Strategies>
        </ArrowContainer>
      )}
    >
      <button type="button" onClick={() => setIsOpen(!isOpen)}>
        Duplicate another slot
      </button>
    </Popover>
  );
}

const Duplicate = styled.span`
  margin: 1rem 0;
  text-transform: capitalize;
  user-select: none;

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
  &:active {
    cursor: default;
    opacity: 1;
  }
`;

const Strategies = styled.div`
  font-family: 'Inter', serif;
  color: #8b97a2;
  font-weight: 500;
  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;

  padding: 1rem 2rem;
  border-radius: 10px;
  border: 1px solid rgba(151, 151, 151, 0.1);
  background-color: #ffffff;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.18),
    0 14px 16px 0 rgba(177, 217, 203, 0.18), 0 5px 16px 0 rgba(0, 0, 0, 0.05);
`;
